import { render, staticRenderFns } from "./EditorialOutcomesStatistics.vue?vue&type=template&id=49709dc3&"
import script from "./EditorialOutcomesStatistics.vue?vue&type=script&lang=js&"
export * from "./EditorialOutcomesStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EditorialOutcomesStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports